<template>
  <div class="dis-ac box-empty" :style="{ 'padding-top': padding, 'padding-bottom': padding }">
    <img class="image" src="../../assets/img/empty.svg" />
    <div class="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '暂无数据'
    },
    padding: {
      type: String,
      default: '20%'
    }
  }
}
</script>

<style lang="scss" scoped>
.box-empty {
  padding-bottom: 80rpx;
  flex-direction: column;

  .image {
    width: 380rpx;
    height: 380rpx;
  }
}

.text {
  height: 42rpx;
  font-size: 30rpx;
  font-weight: 400;
  color: #999999;
  line-height: 42rpx;
}
</style>
